import { HttpEvent, HttpRequest, HttpHandlerFn } from '@angular/common/http';
import { inject } from '@angular/core';
import { Observable } from 'rxjs';
import { Router } from '@angular/router';

import { AuthActionsFacade, AuthSelectorsFacade } from '@ps/auth-data-access';

import { RequestUser } from './domain/request-user';
import { RequestClassifier } from './domain/request-classifier';
import { RouteContext } from './domain/route-context';

export function authInterceptor(
  req: HttpRequest<unknown>,
  next: HttpHandlerFn,
): Observable<HttpEvent<unknown>> {
  const router = inject(Router);
  const _authSelectorsFacade = inject(AuthSelectorsFacade);
  const _authActionsFacade = inject(AuthActionsFacade);

  const request = new RequestClassifier(req);
  if (request.isForPublicUrl()) {
    return next(req);
  }

  const user = _authSelectorsFacade.user().unwrapOr(null);

  if (!user?.token) {
    _authActionsFacade.logout();
    return next(req);
  }

  const routeContext = new RouteContext(req.url, router.url);
  const requestUser = RequestUser.from(routeContext, {
    user,
    hasServiceOperatorAccess: _authSelectorsFacade.hasServiceOperatorAccess(),
    impersonatedBuyer: _authSelectorsFacade.impersonatedBuyer(),
  });

  const clonedReq = req.clone({
    setHeaders: {
      'service-user-id': requestUser.id(),
      'access-token': requestUser.token(),
    },
  });
  return next(clonedReq);
}
